import ScrollTopService from "./scrollTopService";

export default new ScrollTopService();
